// extracted by mini-css-extract-plugin
module.exports = {"moreDetailsCol":"ResultDataRow_moreDetailsCol__3ScHq","moreDetailsRow":"ResultDataRow_moreDetailsRow__1Av01"};